<script>
import Layout from "../../layouts/main";
import ContactUsApi from "@/services/contact-us-api";
import appConfig from "@/app.config";


export default (
  {
  name: "Faq",
  page: {
    title: "Contactez-nous",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {Layout},

    data() {
        return{
            contactUs:{ firstName: '' , secondName: '' , mail: '' , message:''},
        }
    },

    methods :{

      sendContactUsMail(){
        ContactUsApi.sendContactUsMail(this.contactUs)
      }

    }
      
});


</script>

<template>
  <Layout>

    <div class="bg-white text-center pt-md-5 pb-md-5 pt-0 pb-0">
      <div>
        <div class="pt-0">
          <h1 class="pt-5 text-dark text-wrap font-weight-bold" style="font-size:2.5rem;">
            {{$t('contactUs.title')}}
          </h1>
        </div>

        <hr class="separator-line mt-3 mb-3">

        <div class="mt-5 pb-5 pb-md-0">
          <h6 class="header-60-width mx-auto text-dark font-size-16 text-wrap" style="letter-spacing: 0.08em; line-height: 1.8;">
            {{$t('contactInfo.title')}}
          </h6>
        </div>
      </div>
    </div>

<div style="overflow: hidden; position: relative;" class="text-center ">
  <img src="@/assets/images/contact-us-img.jpg" width="auto" height="100%">
  <div class="image-green-overlay"></div>
</div>

<div class="row mr-md-0 ml-md-0 mr-3 ml-3 ">
    <div class="col-12" style="display: contents;">
        <div class="col-lg-2 col-sm-1"/>
        <div class="col-lg-8 col-sm-10"  style="transform: translate(0px , -15%); " >
          
         

          <div class="card h-100 w-100" style="border: 1px solid rgb(221, 221, 221); border-radius:8px;">
            <div class="card-body">
                
          <div class="row" >
            <div class="col-md-6 col-12 my-auto">

              <div class="contact-info text-dark text-center mt-4 ml-2">
                <h3 class="font-weight-bold text-primary font-size-24">{{$t('contactInfo.addressTitle')}}</h3>
                <p class="text-dark font-size-16">{{$t('contactInfo.addressDetails')}}<br>{{$t('contactInfo.shortAddress')}}</p>

                <h3 class="font-weight-bold mt-5 text-primary txt-uppercase font-size-24 ">{{$t('contactInfo.mainContactTitle')}}</h3>
                <div class="font-size-16">
                    <div class="mt-2">
                      <strong>{{$t('contactInfo.mainContactDetails.phoneLabel')}}</strong> 
                      <span class="ml-2">{{$t('contactInfo.mainContactDetails.phoneNumber')}}</span>
                    </div>

                    <div class="mt-2">
                      <strong>{{$t('contactInfo.mainContactDetails.emailLabel')}}</strong> 
                      <a class="ml-2" href="mailto:contact@pubag.tn">{{$t('contactInfo.mainContactDetails.emailAddress')}}</a> 
                    </div>
                  </div>
                

                <!-- <p class="mt-4">
                  {{$t('contactInfo.thankYouMessage')}}
                </p> -->
              </div>


              </div>
            <div class="col-md-6 col-12 mt-md-0 mt-5">

              <div class="mr-2">
                <div>

                  <h1 class="text-primary text-wrap pb-3 font-weight-bold" style="font-size:1.5rem;">
                    {{$t('contactUs.title')}}
                  </h1>

                    <b-form-group>
                      <label for="ref" class="font-size-16 text-dark font-weight-bold ">{{$t('contactUs.label.lastName')}}  </label>
                      <input
                      :placeholder="$t('contactUs.input.lastName')"
                      id="ref"
                      type="text"
                      class="form-control text-dark font-size-16"
                      v-model="contactUs.secondName"
                      />
                    </b-form-group>

                </div>
                <div >
                    <b-form-group>
                      <label for="ref" class="font-size-16 text-dark font-weight-bold ">{{$t('contactUs.label.firstName')}} </label>
                      <input
                      :placeholder="$t('contactUs.input.firstName')"
                      id="ref"
                      type="text"
                      class="form-control font-size-16 text-dark"
                      v-model="contactUs.firstName"
                      />
                    </b-form-group>

                </div>

                  <div class="pr-md-6 mt-2">

                  <b-form-group>
                      <label for="ref" class="font-size-16 text-dark font-weight-bold  mt-3"> {{$t('contactUs.label.address')}}</label>
                      <input
                      :placeholder="$t('contactUs.input.email')"
                      id="ref"
                      type="text"
                      class="form-control text-dark font-size-16"
                      v-model="contactUs.mail"
                      />
                  </b-form-group>

                  <b-form-group>
                      <label for="ref" class="font-size-16 text-dark font-weight-bold  mt-3"> {{$t('contactUs.label.message')}}</label>
                  <textarea
                      :placeholder="$t('contactUs.input.message')"
                      v-model="contactUs.message"
                      class="form-control text-dark font-size-16"
                      :maxlength="3000"
                      rows="6"
                    ></textarea>
                  </b-form-group>

              

                  <b-button  variant="primary" class="getStarted1 font-size-18 btn-block mt-5 " @click="sendContactUsMail()" >{{$t('contactUs.send')}}</b-button>

              </div>

              </div>
            </div>

          </div> 

          </div>
          </div>

             


        </div>
        <div class="col-lg-2 col-sm-1"/>

        </div>

</div>



    

  </Layout>
</template>

<style scoped>

.separator-line {
  width: 15%;
  height: 4px;
  background-color: #137437;
  border: none;
  margin: auto;
}

.header-60-width,
.sub-title-60-width {
  max-width: 80%;
  margin: auto;
}

.image-green-overlay {
  background: linear-gradient(#61b08383, rgba(0, 0, 0, 0.5)); 
  background-size: cover;
  background-position: center;
  
  filter: blur(5px);
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  justify-content: center;
  display: flex;
  align-items: center;
  text-align: center;
  
  transition: filter 0.3s ease, opacity 0.3s ease;
}


</style>
